// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-timeframeFilter-aggregateBySelector-module__container--HPI2u {
  min-width: 120px;
}

.src-js-components-timeframeFilter-aggregateBySelector-module__heading--LmH5w {
  font-size: 11px;
  font-weight: 700;
  color: #A8B0B8;              /* muted gray on dark bg */
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 10px 0;
}

.src-js-components-timeframeFilter-aggregateBySelector-module__list--Whl3X {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.src-js-components-timeframeFilter-aggregateBySelector-module__item--KONVX {
  padding: 8px 18px;
  font-size: 14px;
  font-family: inherit;
  color: #c0ccda;               /* light gray text */
  cursor: pointer;
  background-color: transparent;
  border: none;
  border-radius: 6px;
  transition: background-color 0.15s ease;
  user-select: none;
}

.src-js-components-timeframeFilter-aggregateBySelector-module__item--KONVX:hover:not(.src-js-components-timeframeFilter-aggregateBySelector-module__selected--M2t_w) {
  background-color: rgba(255, 255, 255, 0.06);
}

/* Selected: orange/amber pill (Figma) */
.src-js-components-timeframeFilter-aggregateBySelector-module__selected--M2t_w {
  background-color: #FF9600;    /* amber/orange */
  color: rgba(253, 253, 253, 1);             /* dark text on orange bg */
  font-weight: 700;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/timeframeFilter/aggregateBySelector.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,eAAe,0BAA0B;EACvD,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,cAAc,gBAAgB,oBAAoB;EAClD,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,wCAAwC;AACxC;EACE,yBAAyB,KAAK,iBAAiB;EAC/C,6BAA6B,cAAc,2BAA2B;EACtE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".container {\n  min-width: 120px;\n}\n\n.heading {\n  font-size: 11px;\n  font-weight: 700;\n  color: #A8B0B8;              /* muted gray on dark bg */\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin: 0 0 10px 0;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.item {\n  padding: 8px 18px;\n  font-size: 14px;\n  font-family: inherit;\n  color: #c0ccda;               /* light gray text */\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  border-radius: 6px;\n  transition: background-color 0.15s ease;\n  user-select: none;\n}\n\n.item:hover:not(.selected) {\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n/* Selected: orange/amber pill (Figma) */\n.selected {\n  background-color: #FF9600;    /* amber/orange */\n  color: rgba(253, 253, 253, 1);             /* dark text on orange bg */\n  font-weight: 700;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-js-components-timeframeFilter-aggregateBySelector-module__container--HPI2u`,
	"heading": `src-js-components-timeframeFilter-aggregateBySelector-module__heading--LmH5w`,
	"list": `src-js-components-timeframeFilter-aggregateBySelector-module__list--Whl3X`,
	"item": `src-js-components-timeframeFilter-aggregateBySelector-module__item--KONVX`,
	"selected": `src-js-components-timeframeFilter-aggregateBySelector-module__selected--M2t_w`
};
export default ___CSS_LOADER_EXPORT___;
